import { Button, Drawer } from 'antd';
import { useSyncData } from 'business/scan-site-settings/hooks/use-sync-data';
import { useTranslation } from 'translations/hooks';
import { SynchronizationTag } from 'business/tunnel/pages/ring-scan/components/synchronization-tag';
import { NoConnexion } from 'ui/icons/no-connexion';
import { useNetworkStatus } from 'technical/network/use-network-status';
import { db } from 'technical/db';
import { useLiveQuery } from 'dexie-react-hooks';

export const SynchronizationDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { isOnline } = useNetworkStatus();

  const { upload, isUploading, download } = useSyncData();

  const scanCount = useLiveQuery(() =>
    db.segments.filter((segment) => segment.desynchronizedAt !== null).count(),
  );

  return (
    <Drawer placement="bottom" open={open} onClose={onClose}>
      <div className="flex h-full flex-col items-center-safe justify-between">
        <div className="text-primary w-5/6 text-center">
          {isOnline ? null : <NoConnexion />}
          <h1 className="text-lg font-medium">
            {isOnline
              ? t('tunnel.synchronizationDrawer.title')
              : t('tunnel.synchronizationDrawer.offlineTitle')}
          </h1>
          {isOnline ? null : (
            <p className="text-sm font-medium">
              {t('tunnel.synchronizationDrawer.offlineMessage')}
            </p>
          )}
        </div>

        <span className="flex flex-col items-center">
          <p className="text-primary text-base font-bold">
            {t('tunnel.synchronizationDrawer.scanCount', { count: scanCount })}
          </p>
          <SynchronizationTag isSynced={scanCount === 0} />
        </span>

        <div className="flex w-full flex-col gap-3">
          {isOnline ? (
            <Button
              type="primary"
              className="h-11 w-full"
              onClick={async () => {
                const { success } = await upload();
                if (success) {
                  download();
                }
              }}
              loading={isUploading}
            >
              {t('tunnel.synchronizationDrawer.syncButton')}
            </Button>
          ) : null}
          <Button
            color="primary"
            variant="outlined"
            className="h-11 w-full"
            onClick={onClose}
          >
            {t('tunnel.synchronizationDrawer.cancelButton')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
